import React, { use, useEffect, useState, useRef } from "react";
import { Col, Row, Button, Form } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { loader } from "../../loader";
import { connect } from "react-redux";
import { Editor } from "@tinymce/tinymce-react";
import AliceCarousel from "react-alice-carousel";
import { postData } from "../../axios/apiHelper";
import { ENDPOINT } from "../../axios/apiConfig";
import { getEventCollection } from "../../actions";
import { useSidebar } from "../CommonComponent/LoginLayout";
import { toast } from "react-toastify";
import { uploadImageToServer } from "../surveybuilder/CommonFunctions/CommonFunction";

let eventsetupData = {};
const EventCollectionRegistration = (props) => {
    const editorRef = useRef(null);
    const navigate = useNavigate();
    const { state } = useLocation()
    const { eventIdContext } = useSidebar();
    const eventId = state?.eventId ? state?.eventId : eventIdContext?.eventId ? eventIdContext?.eventId : JSON.parse(localStorage.getItem("EventIdContext"))?.eventId;

    const [templateSaving, setTemplateSaving] = useState("");
    const [templateData, setTemplateData] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [templateClickedd, setTemplateClicked] = useState(false);
    const [templateName, setTemplateName] = useState("");
    const [templatedId, setTemplatedId] = useState(eventsetupData?.setUpData?.registrationPopupId ?? '');
    const [changeEditorCount, setChangeEditorCount] = useState(0);
    const [template, setTemplate] = useState("");
    const slidePrev = () => setActiveIndex(activeIndex - 1);
    const slideNext = () => setActiveIndex(activeIndex + 1);
    const syncActiveIndex = ({ item }) => setActiveIndex(item);
    const responsive = {
        0: { items: 1 },
        568: { items: 2 },
        1024: { items: 5 },
    };

    useEffect(() => {
        getRegistrationTemplates();
    }, []);

    const getRegistrationTemplates = async() => {
        try{
            loader("show")
            setTemplateClicked(false);
            const result = await postData(ENDPOINT.GETEVENTCOLLECTIONREGISTRATION);
            if(eventsetupData?.setUpData?.registrationPopupId){
                let findTemplateIndex = result?.data?.data?.findIndex((el) => el.id === eventsetupData?.setUpData?.registrationPopupId);
                if (findTemplateIndex !== -1) {
                    result.data.data[findTemplateIndex].template = eventsetupData?.setUpData?.registrationPopup;
                    setTemplateData(result?.data?.data);
                    setTimeout(function () {
                        const div_img = document.querySelector("#template_dyn"+findTemplateIndex);
                        if (div_img !== null && typeof div_img != "undefined") {
                            div_img.click();
                        }
                    }, 500);
                }
            }else{
                setTemplateData(result?.data?.data)
                setTimeout(function () {
                    const div_img = document.querySelector("#template_dyn0");
                    if (div_img !== null && typeof div_img != "undefined") {
                        div_img.click();
                    }
                }, 500);
            }
        }catch(err){
            console.log(err,'err')
        }finally{
            loader("hide")
        }
    }

    const templateClicked = (template, e) => {
        const div = document.querySelector("img.select_mm");
        if (div) {
            div.classList.remove("select_mm");
        }
        setTemplateClicked(true);
        setTemplateName(template?.name);
        setTemplate(template?.template);
        setTemplatedId(template?.id);
        setChangeEditorCount(0);
        e.target.classList.toggle("select_mm");
    };

    const updateTemplate = async (e) => {
        e.preventDefault();
        let findTemplateIndex = templateData?.findIndex((el) => el.id === templatedId); 
        if (findTemplateIndex !== -1) {
          templateData[findTemplateIndex].template = templateSaving;
          setTemplateData(templateData);
          toast.success("Template update successfully")
        } else {
          toast.error("Popup not found.");
        }
    };

    const backCollection = async(e) => {
        e.preventDefault();
        await updateCollectionData();
        navigate("/webinar/event/event-collection-page");
    }

    const createCollection = async () => {
        try {
            loader("show");
            await updateCollectionData();
            let payload = {
                event_id: eventId,
                setUpData: eventsetupData?.setUpData,
            };
            if(eventsetupData?.setUpData?.id){
              payload.id = eventsetupData?.setUpData?.id;
              await postData(`${ENDPOINT.UPDATEEVENTCOLLECTION}`, payload);
            }else{
              await postData(`${ENDPOINT.ADDEVENTCOLLECTION}`, payload);
            }
            navigate("/webinar/event/event-collection")
        } catch (err) {
            console.log(err)
            toast.warning("Something went wrong");
        } finally {
            loader("hide");
        }
    }

    const updateCollectionData = async () => {
        let findTemplateIndex = templateData?.findIndex((el) => el.id === templatedId)
        let savedTemplate = templateSaving;
        if (findTemplateIndex !== -1) {
            savedTemplate = templateData[findTemplateIndex].template;
        }
        const body = {
            registrationPopupId: templatedId,
            registrationPopup: savedTemplate
        };

        let updateArticleCollectionData = {
            ...eventsetupData,
            setUpData: {
                ...eventsetupData?.setUpData,
                ...body,
            },
        };
        await props.getEventCollection(updateArticleCollectionData);
    }
    
    return (
        <>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
            <Col className="right-sidebar custom-change event-collection">
                <div className="container-fluid">
                    <div className="row">
                        <div className="top-right-action preview">
                            <div className="d-flex flex-column w-100">
                                <div className="page-top-nav sticky">
                                    <Row className="justify-content-end align-items-center">
                                        <Col md={1}>
                                            <div className="header-btn-left">
                                                <button className="btn btn-primary btn-bordered back" onClick={(e) => backCollection(e)}>
                                                    Back
                                                </button>
                                            </div>
                                        </Col>
                                        <Col md={9}>
                                            <ul className="tabnav-link">
                                                <li className="">
                                                    <Link to="">Select your content collection</Link>
                                                </li>
                                                <li className="">
                                                    <Link to="">Set-up collection page</Link>
                                                </li>
                                                <li className="active active-main">
                                                    <Link to="">Set-Up Registration pop-up</Link>
                                                </li>
                                            </ul>
                                        </Col>
                                        <Col md={2}>
                                            <div className="header-btn">
                                                <Link
                                                    className="btn btn-primary btn-bordered move-draft"
                                                    to="/webinar/event/event-collection"
                                                >
                                                    Cancel
                                                </Link>
                                                {
                                                    eventsetupData?.setUpData?.id
                                                    ?
                                                    <Button className={`btn btn-primary btn-filled next`} onClick={createCollection}>
                                                        Update
                                                    </Button>
                                                    :
                                                    <Button className={`btn btn-primary btn-filled next`} onClick={createCollection}>
                                                        Create
                                                    </Button>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </div>

                                <div className="top-header">
                                    <div className="custom-container">
                                        <div className="row">
                                            <div className="page-title">
                                                <h4>Set-up Your Registration Page of Your Content Collection Page</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <section className="select-mail-template">
                                    <div className="custom-container">
                                        <Row>
                                            <AliceCarousel
                                                mouseTracking
                                                disableDotsControls
                                                activeIndex={activeIndex}
                                                responsive={responsive}
                                                onSlideChanged={syncActiveIndex}
                                            >
                                                {templateData?.map((template, index) => {
                                                    return (
                                                        <React.Fragment key={index}>
                                                            <div className="item" key={index}
                                                                onClick={(e) => templateClicked(template, e)}
                                                            >
                                                                <img
                                                                    id={"template_dyn" + index}
                                                                    src={process.env.REACT_APP_API_KEY_NEW_DESIGN +"/" +template?.image}
                                                                    alt=""
                                                                />
                                                                <p>{template?.name}</p>
                                                            </div>
                                                        </React.Fragment>
                                                    );
                                                })}
                                            </AliceCarousel>

                                            <div className="email-form">
                                                <Form>
                                                    <div className="form-inline d-flex justify-content-end align-items-center">
                                                        <div className="form-group template_builder_div col-12 col-md-12">
                                                            {templateName != "" && (
                                                                <>
                                                                    <div className="template_name">
                                                                        <span>
                                                                            <h4>
                                                                                {templateName}
                                                                            </h4>
                                                                        </span>
                                                                    </div>
                                                                    <div className="form-buttons form-buttons-template right-side">
                                                                        {templateClickedd ? (
                                                                            <>
                                                                                <Button
                                                                                    className={
                                                                                        changeEditorCount == 1
                                                                                            ? "btn btn-primary btn-filled"
                                                                                            : "btn btn-primary btn-filled"
                                                                                    }
                                                                                    onClick={(e) => {
                                                                                        updateTemplate(e);
                                                                                        e.preventDefault();
                                                                                    }}
                                                                                >
                                                                                    Save
                                                                                </Button>
                                                                            </>
                                                                        ) : null}
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </Form>
                                            </div>
                                        </Row>

                                        <Row>
                                           {
                                                templateClickedd ?  
                                                    <Editor
                                                        apiKey="gpl"
                                                        tinymceScriptSrc={
                                                            window.location.origin + "/tinymce/tinymce.min.js"
                                                        }
                                                        onInit={(evt, editor) => (editorRef.current = editor)}
                                                        initialValue={template}
                                                        init={{
                                                            height: 700,
                                                            highlight_on_focus: false,
                                                            menubar:
                                                                "file edit view insert format tools table help",
                                                            plugins:
                                                                "preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons",
                                                            toolbar:
                                                                "undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media link anchor codesample | ltr rtl",
                                                            content_style:
                                                                "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                                            content_css: [
                                                                "https://docintel.app/react_informed_modal.css?v=1.3.6",
                                                                "https://use.fontawesome.com/releases/v5.8.2/css/all.css",
                                                            ],
                                                            file_picker_types: "file image media",
                                                            file_picker_callback: function (
                                                                callback,
                                                                value,
                                                                meta
                                                            ) {
                                                                const input = document.createElement("input");

                                                                if (meta.filetype === "media") {
                                                                    input.setAttribute("type", "file");
                                                                    input.setAttribute("accept", "video/*");

                                                                    input.onchange = async () => {
                                                                        const file = input.files[0];
                                                                        if (file) {
                                                                            let uploadedImageUrl;

                                                                            try {
                                                                                if (meta && meta.width && meta.height) {
                                                                                    uploadedImageUrl =
                                                                                        await uploadImageToServer(
                                                                                            file,
                                                                                            meta.width,
                                                                                            meta.height
                                                                                        );
                                                                                } else {
                                                                                    uploadedImageUrl =
                                                                                        await uploadImageToServer(file);
                                                                                }

                                                                                if (uploadedImageUrl) {
                                                                                    callback(uploadedImageUrl, {
                                                                                        width: 500,
                                                                                        height: 500,
                                                                                    });
                                                                                } else {
                                                                                    console.error("Failed to upload image");
                                                                                }
                                                                            } catch (error) {
                                                                                console.error(
                                                                                    "Error uploading image:",
                                                                                    error
                                                                                );
                                                                            } finally {
                                                                            }
                                                                        }
                                                                    };
                                                                } else {
                                                                    input.setAttribute("type", "file");
                                                                    input.setAttribute("accept", "image/*");
                                                                    const loadingIndicator =
                                                                        document.createElement("div");
                                                                    loadingIndicator.className = "loading-indicator";
                                                                    loadingIndicator.textContent = "Uploading...";

                                                                    input.onchange = async () => {
                                                                        document.body.appendChild(loadingIndicator);

                                                                        const file = input.files[0];
                                                                        if (file) {
                                                                            let uploadedImageUrl;

                                                                            try {
                                                                                if (meta && meta.width && meta.height) {
                                                                                    uploadedImageUrl =
                                                                                        await uploadImageToServer(
                                                                                            file,
                                                                                            meta.width,
                                                                                            meta.height
                                                                                        );
                                                                                } else {
                                                                                    uploadedImageUrl =
                                                                                        await uploadImageToServer(file);
                                                                                }

                                                                                if (uploadedImageUrl) {
                                                                                    callback(uploadedImageUrl, {
                                                                                        width: 500,
                                                                                        height: 500,
                                                                                    });
                                                                                    loader("hide");
                                                                                } else {
                                                                                    console.error("Failed to upload image");
                                                                                }
                                                                            } catch (error) {
                                                                                console.error(
                                                                                    "Error uploading image:",
                                                                                    error
                                                                                );
                                                                            } finally {
                                                                                document.body.removeChild(loadingIndicator);
                                                                            }
                                                                        }
                                                                    };
                                                                }
                                                                input.click();
                                                            },
                                                        }}
                                                        onEditorChange={(content) => {
                                                            setChangeEditorCount(
                                                                parseInt(changeEditorCount) + parseInt(1)
                                                            );
                                                            setTemplateSaving(content);
                                                        }}
                                                    />

                                                : null 
                                            }
                                        </Row>
                                    </div>
                                </section>

                            </div>
                        </div>
                    </div>
                </div>
            </Col>
        </>
    )
}

const mapStateToProps = (state) => {
    eventsetupData = state?.getEventCollection;
    return state;
};

export default connect(mapStateToProps, { getEventCollection: getEventCollection })(
    EventCollectionRegistration
);